module.exports = __webpack_public_path__ + "media/images/homes/intutive_design2x-a31448603e434eca560bc2307e52668b.png";